export default function ym(s) {
  return `${s.substr(0, 4)}/${s.substr(4, 2)}`
}
